"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_1 = tslib_1.__importDefault(require("react"));
const react_components_1 = require("@apollo/react-components");
const reactstrap_1 = require("reactstrap");
const context_1 = require("../../../context");
const react_2 = require("@osmosys/react");
const graphql_1 = require("../../../graphql");
const Yup = tslib_1.__importStar(require("yup"));
const AddWorkspace_1 = require("./AddWorkspace");
const SetupPage_1 = require("./SetupPage");
class Setup extends react_1.default.Component {
    getSchema() {
        const schema = {
            name: Yup.string()
                .min(2, 'Too short')
                .required('Required'),
        };
        return Yup.object().shape(schema);
    }
    render() {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(reactstrap_1.Row, { className: "text-center" },
                react_1.default.createElement(reactstrap_1.Col, null,
                    react_1.default.createElement(react_2.OsmosysLogo, { width: "50", height: "50", marginBottom: 2 }),
                    react_1.default.createElement("h1", null, "Welcome to Osmosys"),
                    react_1.default.createElement("p", { className: "lead" }, "Seamlessly publish content across web and email."),
                    react_1.default.createElement("hr", null))),
            react_1.default.createElement(context_1.OsmosysAppContext.Consumer, null, ({ currentUser, appSettings }) => {
                if (currentUser.workspaceMemberships.length === 0) {
                    if (!appSettings.allowUsersToCreateWorkspaces) {
                        return (react_1.default.createElement(SetupPage_1.SetupPage, { message: "You do not have access to a workspace. If this is an error please contact customer support:" },
                            react_1.default.createElement("p", { className: "lead text-center" },
                                react_1.default.createElement("a", { href: "mailto:contact@yellowbrim.com" }, "contact@yellowbrim.com"))));
                    }
                    return (react_1.default.createElement(SetupPage_1.SetupPage, { message: "To get started, create a workspace:" },
                        react_1.default.createElement(AddWorkspace_1.AddWorkspace, null)));
                }
                if (!currentUser.currentWorkspaceMembership) {
                    return (react_1.default.createElement(SetupPage_1.SetupPage, { message: "To get started, select a workspace:" }, currentUser.workspaceMemberships.map(wsm => (react_1.default.createElement(context_1.OsmosysAppContext.Consumer, { key: 1 }, ({ loadApp }) => (react_1.default.createElement(react_components_1.Mutation, { mutation: graphql_1.setCurrentWorkspaceMembership, variables: {
                            workspaceMembershipId: wsm.workspace.id,
                        }, onCompleted: () => {
                            if (loadApp) {
                                loadApp.refetch();
                            }
                        } }, (mutate, mutationResult) => (react_1.default.createElement("a", { href: "#", onClick: e => {
                            e.preventDefault();
                            mutate();
                        } },
                        react_1.default.createElement(reactstrap_1.Card, { body: true, className: "mb-2" },
                            react_1.default.createElement("div", { className: "d-flex flex-row" },
                                react_1.default.createElement("div", { className: "flex-grow-1" },
                                    react_1.default.createElement("h3", { className: "mb-0" }, wsm.workspace.name)),
                                react_1.default.createElement("div", { className: "flex-col-centered" },
                                    react_1.default.createElement("div", null,
                                        react_1.default.createElement(react_2.OsmosysButton, { size: "sm", osysName: "setup.selectWorkspace", color: "light", iconPosition: "right", faIcon: pro_solid_svg_icons_1.faArrowRight, onClick: e => {
                                                e.preventDefault();
                                                mutate();
                                            } }, "Select")))),
                            react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "WorkspaceMembership", action: "update", apolloError: mutationResult.error })))))))))));
                }
                // if (!currentUser.workspaces[0].stripePaymentSourceID) {
                //   return (
                //     <SetupPage message="To continue, link a payment method:">
                //       <AddPaymentSource />
                //     </SetupPage>
                //   );
                // }
                return (react_1.default.createElement(reactstrap_1.Row, null,
                    react_1.default.createElement(reactstrap_1.Col, { className: "py-5 text-center" },
                        react_1.default.createElement("h4", null, "Setup complete"),
                        react_1.default.createElement("p", null, "You're ready to start using Osmosys"),
                        react_1.default.createElement("div", { className: "d-inline-block" },
                            react_1.default.createElement(react_2.OsmosysButton, { osysName: "setup.homeBtn", color: "primary", osysIcon: "home", iconStyle: "solid", 
                                // size="sm"
                                //   tag={Link}
                                to: "/" }, "Go home")))));
            })));
    }
}
exports.Setup = Setup;
exports.default = Setup;
//# sourceMappingURL=index.js.map